import React from "react";
import { Outlet } from "react-router-dom";
import ModuleTermsAcceptanceGate from "../components/terms/ModuleTermsAcceptanceGate";
import "bootstrap/dist/css/bootstrap.min.css";

/** Home hub page uses its own header + footer (Figma layout). */
export default function HubHomeLayout() {
  return (
    <ModuleTermsAcceptanceGate>
      <Outlet />
    </ModuleTermsAcceptanceGate>
  );
}
